module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e1498"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#c1"
    }
  }, [_vm._v("1. Execution Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2#c2"
    }
  }, [_vm._v("2. Meyer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Night Sounds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.In Harm’s Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Storm Warning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Bloody Passage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. When that Man Is Dead and Gone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Interrogation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Spanish Head")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Run for your Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Small Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Race North")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. May You Die in Ireland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Dark Waters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#c15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Fire From Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "toc_bio"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/bio#bio01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Jack Higgins")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624f1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 75
// module chunks = 0